<template>

  <div >
  
     <div class="db_grid" id="infinite-list">
       <template v-for="(wallItem, ind) in list">
          <div class="grid_element" :class="[templateClass+''+(ind+2)]" :key="ind">
        
            
              <div @click="item=wallItem;goToDetaillPage()" class="grid_box " :class="{[checkProperty(wallItem['data'] ,'config' ,'class')]:checkProperty(wallItem['data'] ,'config' ,'class')  }"  v-bind:style="{ background: getGredieantColor(wallItem) ,border:getBorderColor() }" >
                <span  class="link_arrow"></span>
                <div>
                    <div class="title" >
                      <h3>{{checkProperty( wallItem ,"title" )}}</h3> 
                      <em>{{wallItem.createdOn | timeago}}</em>
                    </div>
                    
                  
                    <div class="discription">
                        <div>
                          <p  class="pointer">{{checkProperty( wallItem ,"description" )}}</p>
                          <p v-if="checkProperty( wallItem ,'data','petitionerName' ) && getTenantTypeId !=2"><b>{{getPetitionerRoleName(wallItem) }}</b>: {{checkProperty( wallItem ,"data","petitionerName" )}}</p>
                        </div>
                        <div class="documents" v-if="checkProperty( wallItem , 'data','documents')">
                            

                            <template v-for="(fItem, findex) in checkProperty( wallItem , 'data','documents')">
                              
                              
                              
                              
                              <span :key="findex" v-tooltip.top-center="fItem.name"   v-on:click.stop.prevent="downloads3file(fItem)"  class="note pointer">
                                 <docType  :item="fItem" />
                              
                              
                              </span>
                              
                            <!-- </template> -->
                            </template>
                            
              
                          
                        </div>
                        
                        <div v-if="wallItem.type =='todo'" class="action__buttons" >
                                          
                        <!---<template 
                        v-if="(['ASSIGN_CUSTOM_CASE_NO'].indexOf(checkProperty( wallItem ,'data' , 'category'))>-1)
                        || (assignmentActivityes.indexOf(checkProperty( wallItem ,'data' , 'category'))>-1) 
                        ||   (checkProperty( wallItem ,'data' , 'category')== 'CASE_APPROVED' && checkProperty( wallItem ,'status') )
                        || (checkProperty( wallItem ,'data' , 'category')== 'APPROVED_BY_DOC_MANAGER' && checkProperty( wallItem ,'status'))
                        || (checkProperty( wallItem ,'data' , 'category')== 'TENANT_CREATED' && checkProperty( wallItem ,'status'))
                        || (checkProperty( wallItem ,'data' , 'category')== 'REQUEST_PETITIONER_SIGN' && checkProperty( wallItem ,'status'))
                        || (checkProperty( wallItem ,'data' , 'category')== 'SUBMIT_TO_USCIS' && checkProperty( wallItem ,'status'))
                        || (['UPDATE_USCIS_RECEIPT_NUMBER' ,'COURIER_TRACKING'].indexOf(checkProperty( wallItem ,'data' , 'category'))>-1 && checkProperty( wallItem ,'status')) 
                        || (['UPDATE_USCIS_RESPONSE'].indexOf(checkProperty( wallItem ,'data' , 'category'))>-1 && checkProperty( wallItem ,'status'))
                        ||(['COMPANY_CREATED'].indexOf(checkProperty( wallItem ,'data' , 'category'))>-1 && checkProperty( wallItem ,'status'))
                        "
                          >-->
                          <template> 
                              <ul>
                              
                              <li v-if="(['ASSIGN_CUSTOM_CASE_NO'].indexOf(checkProperty( wallItem ,'data' , 'category'))>-1)" v-on:click.stop.prevent="item=wallItem;fetchPetitionDetails(wallItem,openSetCaseCodePopup ,'openSetCaseCodePopup')"> <button  class="primary__btn">Assign Case Number </button></li>
                                <li v-if="(assignmentActivityes.indexOf(checkProperty( wallItem ,'data' , 'category'))>-1)" v-on:click.stop.prevent="item=wallItem;fetchPetitionDetails(wallItem,openPopup ,'openPopup')"> <button  class="primary__btn">Assign </button></li>
                                <li :addClas="addClass()" v-if="((checkProperty( wallItem ,'data' , 'category')== 'CASE_APPROVED' && checkProperty( wallItem ,'status')))" v-on:click.stop.prevent="item=wallItem;fetchPetitionDetails(wallItem,openapproveCasePopup ,'openapproveCasePopup')" > <button  class="primary__btn"> Approve Case </button></li>
                                <li :addClas="addClass()" v-if="(checkProperty( wallItem ,'data' , 'category')== 'APPROVED_BY_DOC_MANAGER' && checkProperty( wallItem ,'status'))" v-on:click.stop.prevent="item=wallItem;fetchPetitionDetails(wallItem,openApproveOrRejectDocs,'openApproveOrRejectDocs')" > <button  class="primary__btn"> Approve Documents</button> </li>
                                <li :addClas="addClass()" v-if="( checkProperty( wallItem ,'data' , 'category')== 'REQUEST_PETITIONER_SIGN' && checkProperty( wallItem ,'status'))" v-on:click.stop.prevent="item=wallItem;fetchPetitionDetails(wallItem,showPetitionersign)" ><button  class="primary__btn"> Send for Signing</button> </li>
                                <li :addClas="addClass()" v-if="(checkProperty( wallItem ,'data' , 'category')== 'SUBMIT_TO_USCIS' && checkProperty( wallItem ,'status'))" v-on:click.stop.prevent="item=wallItem;item=wallItem;fetchPetitionDetails(wallItem,getscannedCopiesList)"  > <button  class="primary__btn">Submit to USCIS </button></li>
                                <li :addClas="addClass()" v-if="((['UPDATE_USCIS_RECEIPT_NUMBER' ,'COURIER_TRACKING'].indexOf(checkProperty( wallItem ,'data' , 'category'))>-1 && checkProperty( wallItem ,'status')))" v-on:click.stop.prevent="item=wallItem;fetchPetitionDetails(wallItem,updateTrackingDetails)" > <button  class="primary__btn">Case Filed </button></li>
                                <li :addClas="addClass()" v-if="(['UPDATE_USCIS_RESPONSE'].indexOf(checkProperty( wallItem ,'data' , 'category'))>-1 && checkProperty( wallItem ,'status'))" v-on:click.stop.prevent="item=wallItem;fetchPetitionDetails(wallItem,updateUSCISstatus ,'updateUSCISstatus')"  ><button  class="primary__btn">Update USCIS Status</button></li>
                                
                                
                                <template v-if="(checkProperty( wallItem ,'data' , 'category')== 'TENANT_CREATED' && checkProperty( wallItem ,'status'))">
                                

                                <li :addClas="addClass()" v-on:click.stop.prevent="item=wallItem;openTenantApprovepopup(2,'Approve')" ><button  class="approve_btn"> Approve </button> </li>
                                  <li :addClas="addClass()" v-on:click.stop.prevent="item=wallItem;openTenantApprovepopup(3,'Reject')" ><button  class="reject_btn"> Reject </button> </li>
                                </template>
                                <template v-if="(['COMPANY_CREATED'].indexOf(checkProperty( wallItem ,'data' , 'category'))>-1 && checkProperty( wallItem ,'status'))" >

                                <template v-if="checkProperty(petitioner , 'statusDetails' , 'id')<=1">
                                
                                  <li :addClas="addClass()" v-on:click.stop.prevent="item=wallItem;openApprovepopup(2,'Approve')"><button  class="approve_btn"> Approve</button></li>
                                  <li :addClas="addClass()" v-on:click.stop.prevent="item=wallItem;openApprovepopup(3,'Hold')"><button  class="hold_btn"> Hold</button></li>
                                  <li :addClas="addClass()" v-on:click.stop.prevent="item=wallItem;openApprovepopup(4 ,'Reject')"><button  class="reject_btn"> Reject</button></li>
                              
                                </template>
                                
                                </template>


                              </ul>

                        </template>
                        </div>  
                        
                    </div>                     
                  </div> 
                      

                      <div class="avatar" v-if="checkProperty( wallItem ,'createdByName' )" >
                          <figure ><img  @error="setDefaultPhoto($event)" :src="checkProperty( wallItem,'createdByProfilePicture')"></figure>
                          <div class="avatar_info">
                      

                                <figcaption>{{checkProperty( wallItem ,"createdByName" )}}<p style="display:inline" v-if="checkProperty( wallItem ,'createdByRoleName')">, {{checkProperty( wallItem ,"createdByRoleName" )}}</p>
                                </figcaption>
                          </div>
                      </div>

                                
              </div>
          </div>
        </template>
      </div>   
  

       

      <vs-popup class="holamundo main-popup" title="Assign Case Number" :active.sync="setCode">
      <form data-vv-scope="newCaseNumberForm">
      <div class="popup-accounts-content edit_password" v-if="setCode">       
       
        <div class="form-container padb20"  @click="formerrors=''">
          <div class="form_group" >
            <!-- <i class="placeholder-icon IP-hide-1"></i> -->
            <label class="form_label">Case Number<em>*</em></label>
            <vs-input :key="'caseNumber'"
              type="text" 
              v-validate="'required|min:4|max:30'"
              oninput="this.value = this.value.replace(/[^a-z A-Z 0-9 -_]/g, '');"
              data-vv-as="Case Number"
              name="caseNumber"               
              v-model="newCaseCode"
              placeholder="Case Number"
              class="w-full no-icon-border"
              ref="caseCode"
            />
            <span class="text-danger text-sm" v-show="errors.has('newCaseNumberForm.caseNumber')" >{{ errors.first("newCaseNumberForm.caseNumber") }}<br
          /></span>
          </div>
          <!---
          
          <div class="form_group">
            
            <label class="form_label">Conform Case Number<em>*</em></label>
            <vs-input
              type="text" 
              v-validate="'required|checkConformCaseNum:caseCode'"
              data-vv-as="Conform Case Number"
               placeholder="Conform Number"
              v-model="confCaseCode"
              name="newCaseCode"
              class="w-full no-icon-border"
            />
             <span class="text-danger text-sm" v-show="errors.has('newCaseNumberForm.newCaseCode')">{{
            errors.first("newCaseNumberForm.newCaseCode")
          }}</span>
          </div>
          -->
          
       

         <div class="text-danger text-sm formerrors" v-show="formerrors">
          <vs-alert
            color="warning"
            class="warning-alert reg-warning-alert no-border-radius"
            icon-pack="IntakePortal"
            icon="IP-information-button"
            active="true"
          >
            {{ formerrors }} 
          </vs-alert>
        </div>
         </div> 
        <div class="popup-footer relative"> 
          <!-- <div class="password-count">
          <i class="icon IP-lock"></i> Password must contain 6 to 15 characters
        </div> -->
        <div class="d-flex">
        <vs-button color="dark" @click="setCode=false ,settingCaseNumber=false" class="cancel" type="filled">Cancel</vs-button>
      
            <vs-button class="save" type="filled" @click="SetCaseCodeAction" :disabled="settingCaseNumber">
             <figure v-if="settingCaseNumber" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
            Assign</vs-button> 
        </div>
        </div>
      </div> 
      </form>
       </vs-popup>



  
       
      <!----Petition Submit to Reviewer---->
        <vs-popup
        v-if="(assignmentActivityes.indexOf(checkProperty( item ,'data' , 'category'))>-1)"
        class="holamundo main-popup"
        :title="getlableName()"
        :active.sync="showPopup"
      >
        <form data-vv-scope="assignmentForm" class="relative">
    
          <div class="popup_info" v-if="usersList.length>0" >
            <span><eye-icon size="1.5x" class="custom-class"></eye-icon></span>
            <div class="info_list">
              <ul v-if="usersList.length>0">
              <template v-for="(usr ,usrIndx) in addReviewrsRolesList()">
               <li :key="usrIndx">{{usr['roleName']}}</li>
              </template>
                
              </ul> 
            </div>
          </div>
          <div class="form-container" @click="formErrors=''">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="form_group">
                  <label for class="form_label mb-0">Reviewer<em>*</em></label>
                  <div class="con-select w-full select-large">
                    <multiselect
                      name="users"
                      v-model="selectedUser"
                      :close-on-select="true"
                      v-validate="'required'"
                      :multiple="false"
                      :show-labels="false"
                      @input="selectUesr"
                      label="name"
                      data-vv-as="Reviewer"
                      placeholder="Select Reviewer"
                      :options="usersList"
                      :searchable="true"
                      :allow-empty="false"
                  >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                                                      <span
                                                      class="multiselect__selectcustom"
                                                      v-if="values.length && !isOpen"
                                                      >{{ values.length }} selected</span
                                                      >
                                                      <span
                                                      class="multiselect__selectcustom"
                                                      v-if="values.length && isOpen"
                                                      ></span>
                                                  </template>
                    </multiselect>
                  </div>
                </div>

                <span
                  class="text-danger text-sm"
                  v-show="errors.has('assignmentForm.users')"
                >{{ errors.first("assignmentForm.users") }}</span>
              </div>
              
              <div class="vx-col w-full">
                <div class="form_group">
                <label class="form_label">Comments</label>
                <!-- <vs-textarea
                  data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="comments"
                  name="comments" 
                  class="w-full"
                /> -->
                <ckeditor data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="comments"
                  name="comments" 
                  class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>


                <span
                  class="text-danger text-sm"
                  v-show="errors.has('assignmentForm.comments')"
                >{{ errors.first("assignmentForm.comments") }}</span>
              </div>
              </div>
            </div>
            <div class="text-danger text-sm formerrors" v-show="formErrors">
            
              <vs-alert
                color="warning"
                class="warning-alert reg-warning-alert no-border-radius"
                icon-pack="IntakePortal"
                icon="IP-information-button"
                active="true"
              >{{ formErrors }}</vs-alert>
              
            </div>
          </div>
          
          
         
          <div class="popup-footer">
           <span class="loader" v-if="loading" ><img src="@/assets/images/main/loader.gif"></span>
           <vs-button
          
              color="success"
              v-on:click.stop.prevent="showPopup =false ;"
              class="btn cancel"
              type="filled"
            >Cancel </vs-button>
            <vs-button
            :disabled="loading"
              color="success"
              v-on:click.stop.prevent="submitAction()"
              class="save"
              type="filled"
            >Assign </vs-button>
          </div>
        </form>
      </vs-popup>
   

   <!----Case Approve---->
      <vs-popup

      class="holamundo main-popup"
      :title="'Approve Case'" 
      :active.sync="approveCasePopup"
    >

      <form data-vv-scope="approvecase">

        <div class="form-container" >
          <div class="vx-row">
            
            <div class="vx-col w-full">
            <div class="form_group">
              <label class="form_label">Comments</label>
              <!-- <vs-textarea
                data-vv-as="Note"
                v-validate="'required'"
                v-model="comments"
                name="comments"
              
                class="w-full"
              /> -->
              <ckeditor data-vv-as="Note"
                v-validate="'required'"
                v-model="comments"
                name="comments"
              
                class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>

              <span
                class="text-danger text-sm"
                v-show="errors.has('approvecase.comments')"
              >{{ errors.first("approvecase.comments") }}</span>
            </div>
            </div>
          </div>
          <div class="text-danger text-sm formerrors" v-show="formErrors">
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
            >{{ formErrors }}</vs-alert>
          </div>
        </div>
        <div class="popup-footer">
          <span class="loader" v-if="loading" ><img src="@/assets/images/main/loader.gif"></span>
          <vs-button
          
              color="success"
              v-on:click.stop.prevent="approveCasePopup =false "
              class="btn cancel"
              type="filled"
            >Cancel </vs-button>
          <vs-button
              :disabled="comments =='' || comments.trim() =='' || loading" 
            color="success"
            v-on:click.stop.prevent="caseApproveCaseAction()"
            class="save"
            type="filled"
          >Approve</vs-button>
        </div>
      </form>
            
      </vs-popup>

      <!--- Approve or rejet Documents-->
       <vs-popup
     
        class="holamundo main-popup"
        title=" Approve or reject documents"
        :active.sync="approveOrRejectDocs"
      >
      
        <form data-vv-scope="approveOrRejectDocsForm">
      
          <div class="form-container" >
            <div class="vx-row">
             
              <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Comments</label>
                <!-- <vs-textarea
                  data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="comments"
                  name="comments"
               
                  class="w-full"
                /> -->
                <ckeditor  data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="comments"
                  name="comments"
               
                  class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>

                <span
                  class="text-danger text-sm"
                  v-show="errors.has('approveOrRejectDocsForm.comments')"
                >{{ errors.first("approveOrRejectDocsForm.comments") }}</span>
              </div>
              </div>
            </div>
            <div class="text-danger text-sm formerrors" v-show="formErrors">
              <vs-alert
                color="warning"
                class="warning-alert reg-warning-alert no-border-radius"
                icon-pack="IntakePortal"
                icon="IP-information-button"
                active="true"
              >{{ formErrors }}</vs-alert>
            </div>
          </div>
          <div class="popup-footer">
           <span class="loader" v-if="loading" ><img src="@/assets/images/main/loader.gif"></span>
           <vs-button
          
              color="dark"
              v-on:click.stop.prevent="approveOrRejectDocs =false "
              class="btn cancel"
              type="filled"
            >Cancel </vs-button>

            <vs-button
               :disabled="comments =='' || comments.trim() =='' || loading" 
              color="success"
              v-on:click.stop.prevent="approveOrRejectDocsAction('REJECT_BY_DOC_MANAGER')"
              class="save"
              type="filled"
            >Reject</vs-button>
            <vs-button
               :disabled="comments =='' || comments.trim() =='' || loading" 
              color="success"
              v-on:click.stop.prevent="approveOrRejectDocsAction('APPROVED_BY_DOC_MANAGER')"
              class="save"
              type="filled"
            >Approve</vs-button>
          </div>
        </form>
             
      </vs-popup>

      <!----Tenant Approve Or Reject --->
      <vs-popup class="holamundo main-popup" :title="popuptntTxt+' Customer'" :active.sync="approveTenantConformpopUp">
      <div class="form-container">
        
        <div class="vx-row" v-if="[2].indexOf(selectedtenantStatus)>-1" >
          <div class="vx-col w-full">
          <p>{{tntActionText}}</p>
            
          </div>
                    
        </div>

        <!--------------If reject take comment------->
       
          <div v-if="[3,4,5].indexOf(selectedtenantStatus)>-1" class="vx-row mar0 ">
            <label class="custom-label mb-0 mt-0">Write a comment</label>
            <!-- <vs-textarea v-model="comments"  class="w-full" /> -->
            <ckeditor v-model="comments"  class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>

         
          </div>

          <div class="text-danger text-sm formerrors" v-show="formErrors">
              <vs-alert
                color="warning"
                class="warning-alert reg-warning-alert no-border-radius"
                icon-pack="IntakePortal"
                icon="IP-information-button"
                active="true"
              >{{ formErrors }}</vs-alert>
            </div>
       
      </div>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled" v-on:click.stop.prevent="approveTenantConformpopUp=false;selectedtenantStatus=0;comments=''">Cancel</vs-button>
        <vs-button color="success" class="save" :disabled="[3,4,5].indexOf(selectedtenantStatus)>-1  && comments==''" type="filled" v-on:click.stop.prevent="changetenantStatus()">{{popuptntTxt}}</vs-button>
      </div>
    </vs-popup>

    <!--Request for sign in--->
    <vs-popup
        class="holamundo main-popup filling_popup"
        title="Submit for Signing"
        :active.sync="requestsignPopup"
        v-if="(requestsignPopup && formsAndLettersList.length >=0)"
      >
        <!-- <vs-popup class="holamundo"  title="Lorem ipsum dolor sit amet" :active.sync="filingFeesPopup"> -->
        <form data-vv-scope="requestsignform" @submit.prevent>
          <div class="form-container padt25">
            <!--- FORMS AND LATTERS SECTOION -->
              <div class="vx-col w-full" >
                <div>
               
                  <h4 class="formsandlettes_title">Required Documents</h4>
                   <ul v-on:click.stop.prevent="checkFormsandLatters =false" class="formsandlettes">
                     <template  v-for="(forms, index) in formsAndLettersList"   >
                        <li  :key="index"  v-if="forms.statusId==2" >                          
                          <vs-checkbox @change="selectFormsandLatters(index ,forms)"  :name="'selectedForSigning_'+index"  v-model="forms.selectedForSigning" class=""></vs-checkbox>
                          {{forms.name}} 
                        </li>
                     </template>
                   </ul>

                  
                   <span class="text-danger text-sm" v-if="checkFormsandLatters" >
                     Forms and latters required
                    </span>
                    

                   
                </div>
              </div>


            <div class="vx-col w-full" @keyup="requestsignCommentError =false" >
             <div class="form_group">
                <label class="form_label">Comments</label>
              <!-- <vs-textarea
                data-vv-as="Comments"
                v-validate="'required'"
                v-model="comments"
                name="requestsignformcomments"
               
                class="w-full"
              /> -->
              <ckeditor  data-vv-as="Comments"
                v-validate="'required'"
                v-model="comments"
                name="requestsignformcomments"
               
                class="w-full" :editor="editor" :config="editorConfig"></ckeditor>

              <span
                class="text-danger text-sm" v-if="errors.has('requestsignform.requestsignformcomments')">
                {{ errors.first("requestsignform.requestsignformcomments") }}
                </span>
                <span
                class="text-danger text-sm" v-else-if="requestsignCommentError">
                * Comments are required
                </span>
               </div>
            </div>

            <div class="vx-col w-full" style="margin-bottom:20px;">
          <!--- notifyPetitioner==  {{notifyPetitioner}} --  emailDocsForSign == {{ emailDocsForSign}} checkSendAttachments()-->
                                  
                                  <ul class="demo-alignment custom-radio" vs-type="flex" vs-align="center">
                                    <li>
                                    
                                      <vs-checkbox
                                        @change="checkSendAttachments('notifyPetitioner')"
                                        vs-name="workLocation"
                                        v-model="notifyPetitioner"
                                        :disabled="emailDocsForSign"
                                      >Notify Signer </vs-checkbox>
                                    </li>
                                     <li>
                                      <vs-checkbox
                                        vs-name="emailDocsForSign"
                                          @change="checkSendAttachments('emailDocsForSign')"
                                        v-model="emailDocsForSign"
                                       >Send Documents by Email </vs-checkbox>
                                       <!-- Send Email Attachments -->
                                    </li>
                                  </ul>
                                </div>


           

          </div>

          <div class="popup-footer">
          <span class="loader" v-if="loading" ><img src="@/assets/images/main/loader.gif"></span>
          <vs-button color="dark" class="cancel" type="filled" v-on:click.stop.prevent="requestsignPopup=false;">Cancel</vs-button>
            <vs-button
            :disabled="loading"
              color="success"
              v-on:click.stop.prevent="submitpetitionrequest"
              class="save"
              type="filled"
            >Submit</vs-button>
          </div>
        </form>
    </vs-popup>
      
      <!--- Submit to uscis  --->
      <vs-popup
     
        class="holamundo main-popup"
        title="Submit to USCIS"
        :active.sync="submiTouscisPopup"
      >
      
        <form data-vv-scope="activityfoform">
      
          <div class="form-container" >
            <div class="vx-row">
             
              <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Comments</label>
                <!-- <vs-textarea
                  data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="comments"
                  name="comments"
               
                  class="w-full"
                /> -->
                <ckeditor  data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="comments"
                  name="comments"
               
                  class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>

                <span
                  class="text-danger text-sm"
                  v-show="errors.has('activityfoform.comments')"
                >{{ errors.first("activityfoform.comments") }}</span>
              </div>
              </div>
            </div>
            <div class="text-danger text-sm formerrors" v-show="formErrors">
              <vs-alert
                color="warning"
                class="warning-alert reg-warning-alert no-border-radius"
                icon-pack="IntakePortal"
                icon="IP-information-button"
                active="true"
              >{{ formErrors }}</vs-alert>
            </div>
          </div>
          <div class="popup-footer">
           <span class="loader" v-if="loading" ><img src="@/assets/images/main/loader.gif"></span>
            <vs-button color="dark" class="cancel" type="filled" v-on:click.stop.prevent="submiTouscisPopup=false;">Cancel</vs-button>
            <vs-button
               :disabled="comments =='' || comments.trim() =='' || loading" 
              color="success"
              v-on:click.stop.prevent="submitToUscisAction()"
              class="save"
              type="filled"
            >Submit</vs-button>
          </div>
        </form>
             
      </vs-popup>

  <!---Courier Tracking---->
    <vs-popup
    v-if="updateTrackingPopup"
      class="holamundo main-popup"
      title="Update Tracking Details"
      :active.sync="updateTrackingPopup"
    >
      <!-- <vs-popup class="holamundo"  title="Lorem ipsum dolor sit amet" :active.sync="filingFeesPopup"> -->
      <form data-vv-scope="trackingform" class="trackingform">
        <div class="form-container" @keyup="formErrors =''" v-on:click.stop.prevent="formErrors =''">
          <!--  -->
          <div  v-if="petitionDetails.nextWorkflowActivity=='COURIER_TRACKING'" >
            <div class="vx-col w-full">
              <div class="form_group">
              <vs-input :key="'trackingId'"
                style="width:100%"
                data-vv-as="Tracking ID"
                v-validate="'required'"
                v-model="tracking.trackingId"
                name="trackingId"
                label="Tracking ID"
                
              />
              <span class="text-danger text-sm" v-show="errors.has('trackingform.trackingId')">{{ errors.first("trackingform.trackingId") }}</span>
            </div>
            </div>   
              
            <div class="vx-col w-full" >
              <div class="form_group">
                <label class="form_label">Courier</label>
                <div class="con-select">
                  <multiselect
                    data-vv-as="Courier"
                    v-model="tracking.courier"
                    @input="changedCourier()"
                    :options="courierList"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Select Courier"
                    label="name"
                    track-by="name"
                    :preselect-first="false"
                    name="Courier"
                    v-validate="'required'"
                    
                  >
                    <template slot="selection" slot-scope="{ values,  isOpen }">
                      <span
                        class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen"
                      >{{ values.length }} options selected</span>
                    </template>
                  </multiselect>
                </div>
                <span class="text-danger text-sm"  v-show="errors.has('trackingform.Courier')">{{ errors.first("trackingform.Courier") }}</span>
              </div>
            </div>
              
            
              
          </div>
          
    <!--  -->
          <div v-if="petitionDetails.nextWorkflowActivity=='UPDATE_USCIS_RECEIPT_NUMBER'" >
            <div class="vx-col w-full">
              <vs-input :key="'receiptNumber'"
                style="width:100%"
                data-vv-as="Receipt Number"
                v-validate="'required'"
                v-model="tracking.receiptNumber"
                name="receiptNumber"
                label="Receipt Number"
              />
            </div>
            <span class="text-danger text-sm" v-show="errors.has('trackingform.receiptNumber')">{{ errors.first("trackingform.receiptNumber") }}</span>
                
            <div class="vx-col w-full">
            <div class="form_group">
              <label class="form_label">Comments</label>

                      <!-- <vs-textarea
                data-vv-as="Comments"
                v-validate="'required'"
                v-model="tracking.receiptName" 
                name="receiptName"
                
                class="w-full"
              /> -->
              <ckeditor data-vv-as="Comments"
                v-validate="'required'"
                v-model="tracking.receiptName" 
                name="receiptName"
                
                class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>
              </div>


          
            </div>
            <span class="text-danger text-sm" v-show="errors.has('trackingform.receiptName')">{{ errors.first("trackingform.receiptName") }}</span>

          
            <div class="vx-col w-full upload-wrap">
              <file-upload
                v-model="trackingdoc"
                class="file-upload-input mb-0"
                style="height:50px;"
                name="trackingdoc"
                :multiple="false"
                v-validate="'required'"
                data-vv-as="Documents"
                :accept="allDocEntity"
                :emitCategory="'trackingdoc'"
                @updateData="updateData"
              >
              <!-- @input="selectedDocuments(index, trackingdoc)" -->
                <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                Upload * 
              </file-upload>
              <span class="loader" v-if="filesAreuploading"><img src="@/assets/images/main/loader.gif"></span>
              <span class="file-type marb15">(File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)</span>
    <span class="text-danger text-sm" v-show="errors.has('trackingform.trackingdoc')">{{ errors.first("trackingform.trackingdoc") }}</span>
            
              

              <ul class="uploaded-list">
                    <template v-for="(item, index) in trackingdoc">
                        <vs-chip v-on:click.stop.prevent="remove(index , trackingdoc)" :key="index" closable >
                            {{ item.name }}
                        </vs-chip>
                    </template>
                </ul>
            </div>
          </div>
        </div>

        <div class="text-danger text-sm formerrors" v-if="formErrors!=''">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ formErrors }}</vs-alert>
        </div>

        <div class="popup-footer">
        <span class="loader" v-if="loading" ><img src="@/assets/images/main/loader.gif"></span>
        <vs-button color="dark" class="cancel" type="filled" v-on:click.stop.prevent="updateTrackingPopup=false;">Cancel</vs-button>
          <vs-button color="success" :disabled="loading" v-on:click.stop.prevent="updateTracking" class="save" type="filled">Submit</vs-button>
        </div>
      </form>
    </vs-popup>

      <!----Update USCIS---->
       <vs-popup
         v-if="updateUSCISstatusPopup"
        class="holamundo main-popup trackingpopup"
        title="Update USCIS Status"
        :active.sync="updateUSCISstatusPopup"
      >
        <!-- <vs-popup class="holamundo"  title="Lorem ipsum dolor sit amet" :active.sync="filingFeesPopup"> -->
        <form data-vv-scope="uscisstatus" class="trackingform">
          <div class="form-container">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="con-select w-full select-large marb15 mt-0">
                  <label class="form_label">Case Status</label>
                  <multiselect
                    name="caseType"
                    v-validate="'required'"
                    v-model="casestatus"
                    :show-labels="false"
                    track-by="value"
                    label="text"
                    data-vv-as="Case Status"
                    placeholder="Choose Case Status"
                    :options="uscisstatuslist"
                    :searchable="true"
                    :allow-empty="false"
                  ></multiselect>
                </div>

                <span
                  class="text-danger text-sm"
                  v-show="errors.has('uscisstatus.caseType')"
                >{{ errors.first("uscisstatus.caseType") }}</span>
              </div>
              <div
                v-if="checkProperty(casestatus ,'value') =='USCIS_RECEIVED_RFE' "
                class="vs-col d-felx d-received_wrap"
              >
                <div class="vs-col">
                  <label class="date-picker-label">RFE Issued Date</label>

                  <datepicker  :typeable="true"
                    icon-pack="IntakePortal"
                    icon-after
                    name="issuedDate"
                    v-model="issuedDate"
                    v-validate="'required'"
                    icon="IP-calendar-1"
                    data-vv-as="RFE Issued Date"
                    placeholder="DD/MM/YYYY"
                    :open-date="new Date(openDate)"
                    :disabled-dates="{from: new Date(startEligibleDate)}"
                  ></datepicker>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('uscisstatus.issuedDate')"
                  >{{ errors.first("uscisstatus.issuedDate") }}</span>
                </div>

                <div class="vs-col">
                  <label class="date-picker-label">RFE Recevied Date</label>
                  <datepicker  :typeable="true"
                    icon-pack="IntakePortal"
                    icon-after
                    name="receivedDate"
                    v-model="receivedDate"
                    v-validate="'required'"
                    icon="IP-calendar-1"
                    data-vv-as="RFE Recevied Date"
                    placeholder="DD/MM/YYYY"
                    :open-date="new Date(openDate)"
                    :disabled-dates="{from: new Date(startEligibleDate)}"
                  ></datepicker>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('uscisstatus.receivedDate')"
                  >{{ errors.first("uscisstatus.receivedDate") }}</span>
                </div>

                <div class="vs-col">
                  <label class="date-picker-label">RFE Due Date</label>
                  <datepicker  :typeable="true"
                    icon-pack="IntakePortal"
                    icon-after
                    name="dueDate"
                    v-model="dueDate"
                    v-validate="'required'"
                    icon="IP-calendar-1"
                    data-vv-as="RFE Due Date"
                    placeholder="DD/MM/YYYY"
                    :open-date="new Date(openDate)"
                    :disabled-dates="{from: new Date(startEligibleDate)}"
                  ></datepicker>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('uscisstatus.dueDate')"
                  >{{ errors.first("uscisstatus.dueDate") }}</span>
                </div>
              </div>
              
              <!-----
              <div class="vx-col w-full upload-wrap">
                <file-upload
                  v-model="uscisdocument"
                  class="file-upload-input mb-0"
                  style="height:50px;"
                  name="trackingdoc"
                  :multiple="false"
                  v-validate="'required'"
                  data-vv-as="Documents"
                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  @input="selectedDocuments(index, uscisdocument)"
                >
                  <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                  Upload
                </file-upload>
                
                <span class="loader" v-if="filesAreuploading"><img src="@/assets/images/main/loader.gif"></span>
                <span class="file-type marb15">(File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)</span>
                 <span class="text-danger text-sm" v-show="errors.has('uscisstatus.trackingdoc')">{{ errors.first("uscisstatus.trackingdoc") }}</span>


                <ul class="uploaded-list">
                      <template v-for="(item, index) in uscisdocument">
                          <vs-chip v-on:click.stop.prevent="remove(index , trackingdoc)" :key="index" closable >
                              {{ item.name }}
                          </vs-chip>
                      </template>
                  </ul>
              </div>
              -->

              <!----------------New Document Start------>
                        <div class="vx-col w-full ">
                           
                                <div class="uploadsec_wrap upload_uscis">
                                    <div class="w-full">
                                        <div class="relative">
                <file-upload
                  v-model="uscisdocument"
                  class="file-upload-input mb-0"
                  style="height:50px;"
                  name="trackingdoc"
                  :multiple="false"
                  v-validate="'required'"
                  data-vv-as="Documents"
                  :accept="allDocEntity"
                  @updateData="updateData"
                  :emitCategory="'uscisdocument'"
                  
                >
                <!-- @input="selectedDocuments(index, uscisdocument)" -->
                  <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                  Upload
                </file-upload>
                
                <span class="loader" v-if="filesAreuploading"><img src="@/assets/images/main/loader.gif"></span>
                </div>
                <span class="file-type">(File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)</span>
                 <span class="text-danger text-sm" v-show="errors.has('uscisstatus.trackingdoc')">{{ errors.first("uscisstatus.trackingdoc") }}</span>


                                        <VuePerfectScrollbar class="scrollbardoc">
                                            <div class="uploded-files_wrap mb-5" v-if="uscisdocument.length >0 ">
                                                <div class="w-full" v-for="(fil, fileindex) in uscisdocument" :key="fileindex">
                                                    <div class="uploded-files">
                                                        <vx-input-group class="form-input-group">
                                                            <vs-input v-on:keyup="fileNameChenged(fil)"  v-validate="'required'" class="w-full" :name="'fName'+fileindex" v-model="uscisdocument[fileindex]['name']" data-vv-as="File Name" />
                                                           <!-- <span class="text-danger text-sm" v-show="!uscisdocument[fileindex]['name']">Please Enter file name</span> -->
                                                            <span class="text-danger text-sm" v-show="errors.has('uscisstatus.fName'+fileindex)">{{ errors.first('uscisstatus.fName'+fileindex) }}</span>

                                                            
                                                        </vx-input-group>

                                                        <div class="form_group">
                                                       
           
                                                          <label class="form_label">Document Type</label>
                                                        <div class="con-select w-full">                  
                                                          <multiselect
                                                            :name="'documentType_'+fileindex"
                                                            v-validate="'required'"
                                                            v-model="fil.documentType"
                                                            :show-labels="false"
                                                           
                                                            data-vv-as="Document Type"
                                                            placeholder="Document Type"
                                                            :options="documentTypes"
                                                            :searchable="true"
                                                            :allow-empty="false"
                                                          ></multiselect>
                                                        
                                                        <span
                                                          class="text-danger text-sm"
                                                          v-show="errors.has('uscisstatus.documentType_'+fileindex)"
                                                        >{{ errors.first('uscisstatus.documentType_'+fileindex) }}</span>
                                                        </div>
                                                        <div class="delete" style="z-index:999" @click="remove(fileindex , trackingdoc)">
                                                                <img src="@/assets/images/main/delete-row-img.svg" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </VuePerfectScrollbar>
                                    </div>
                                </div>
                            
                        </div>

<!----------------New Document End ------->



              <div class="vx-col w-full">
               <div class="form_group">
                <label class="form_label">Comments</label>
                <!-- <vs-textarea
                  data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="comments"
                  name="usciscomments"
                  class="w-full"
                /> -->
                <ckeditor   data-vv-as="Comments"
                  v-validate="'required'"
                  v-model="comments"
                  name="usciscomments"
                  class="w-full" :editor="editor" :config="editorConfig"></ckeditor>

                <span
                  class="text-danger text-sm"
                  v-show="errors.has('uscisstatus.usciscomments')"
                >{{ errors.first("uscisstatus.usciscomments") }}</span>
               </div>
              </div>
            </div>

            
          </div>
          <div class="text-danger text-sm formerrors" v-if="formErrors!=''">
                    <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ formErrors }}</vs-alert>
                </div>

          <div class="popup-footer">
           <span class="loader" v-if="loading"><img src="@/assets/images/main/loader.gif"></span>
           <vs-button color="dark" class="cancel" type="filled" v-on:click.stop.prevent="updateUSCISstatusPopup=false;">Cancel</vs-button>
            <vs-button color="success" :disabled="filesAreuploading || loading" v-on:click.stop.prevent="petitionApproval()" class="save" type="filled">Submit</vs-button>
          </div>
        </form>
      </vs-popup>

      <!---Prtitioner Approve---->
      <vs-popup class="holamundo main-popup" :title="popupbtnTxt+' Company'" :active.sync="approveConformpopUp">
      <div class="form-container">
        
        <div class="vx-row">
          <div class="vx-col w-full">
          <p>{{actionText}}</p>
            
          </div>
          
        </div>
          <div class="text-danger text-sm formerrors" v-if="formErrors!=''">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ formErrors }}</vs-alert>
          </div>
       
      </div>
      <div class="popup-footer">
       <span class="loader" v-if="loading"><img src="@/assets/images/main/loader.gif"></span>
        <vs-button color="dark" class="cancel" type="filled" v-on:click.stop.prevent="approveConformpopUp=false">Cancel</vs-button>
        <vs-button color="success" :disabled="loading" class="save" type="filled" v-on:click.stop.prevent="changetPetitionerstatus()">{{popupbtnTxt}}</vs-button>
      </div>
    </vs-popup>
    <!------- documentsViewPopup --->
     <vs-popup class="holamundo main-popup" :title="'Documents View'" :active.sync="documentsViewPopup">
      <div class="form-container">
        
        <div class="vx-row">
          <div class="vx-col w-full">
            <template v-for="(item, index) in checkProperty( item , 'data','documents')">
              
              <span :key="index" :title="item.name"  v-on:click.stop.prevent="downloads3file(item)"  class="note"><img src="@/assets/images/main/note_icon.png"></span> 
            </template>
            
          </div>
          
        </div>
        
       
      </div>
      <div class="popup-footer">
      
        <vs-button color="dark" class="cancel" type="filled" v-on:click.stop.prevent="documentsViewPopup=false">Cancel</vs-button>
      
      </div>
    </vs-popup>
   
   </div>
</template>

<script>
import Datepicker from "vuejs-datepicker-inv";
//import FileUpload from "vue-upload-component/src";
import Avatar from 'vue-avatar'
import moment from 'moment'
import { EyeIcon } from 'vue-feather-icons'
import Vue from 'vue'
  import _ from "lodash";
import VTooltip from 'v-tooltip'
import JQuery from "jquery";
Vue.use(VTooltip)
import docType from "@/views/common/docType.vue"
;
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import FileUpload from "@/views/FileUpload.vue";
var _isotope;
export default {
        components: {
        Avatar,
        FileUpload,
        Datepicker,
        EyeIcon,
        docType
    },
    
  props: {
    list:{
      type: Array,
      default:new Array(),
    },
    lableData:{
      type: Array,
      default:new Array(),
    },
    userRolelist:{
      type: Array,
      default:new Array(),
    },
    templateClass:{
        type:String,
        default:'box'
    },  
    all_statusids: {
      type: Array,
      default:new Array(),
    },
    
     itemTemplate:{
         type: Array,
      default:new Array(),

    },
    
     
  },
  methods:{
    updateData(docs, category){
      if(category == 'uscisdocument' ){
        this.uscisdocument = docs
      }
      if(category == 'trackingdoc' ){
        this.trackingdoc = docs
      }
    },
    checkSendAttachments(action=''){
      setTimeout(() =>{
            if(this.notifyPetitioner && action=='notifyPetitioner'){
          //  this.emailDocsForSign =false;
         
            }
            
            if(this.emailDocsForSign && action=='emailDocsForSign'){
              this.notifyPetitioner =true;
            }

      } ,10)
      
    },
    initIsotop(resetIsotop=false){
      
      setTimeout(() => {
          

             // Force grid to relayout
             if(resetIsotop && this.isotopGrid){
                this.isotopGrid.isotope('destroy')
                //this.isotopGrid.isotope('layout');
                this.isotopGrid=  jQuery(".db_grid").isotope({
              layoutMode: "packery",
              itemSelector: ".grid_element",
              masonry: {
                horizontalOrder: true,
              },
            });

             }else{
               this.isotopGrid=  jQuery(".db_grid").isotope({
              layoutMode: "packery",
              itemSelector: ".grid_element",
              masonry: {
                horizontalOrder: true,
              },
            });
            if (jQuery(".db_grid").height() <= 50) {
              jQuery(".db_grid").height("auto");
              var _h = jQuery(".db_grid").innerHeight();
              jQuery(".db_grid").height(_h);
            }

             }
          

          
            // this.$vs.loading.close();
          }, 100);
    },
     /*** Computed ***/
     /*
      isAssignmentActivity(){

        //(assignmentActivityes.indexOf(checkProperty( item ,'data' , 'category'))>-1)

        return (this.assignmentActivityes.indexOf(this.checkProperty( this.item ,'data' , 'category'))>-1)?true:false;

      },
      isCustomeCode(){
         return (['ASSIGN_CUSTOM_CASE_NO'].indexOf(this.checkProperty( this.item ,'data' , 'category'))>-1)?true:false;

      },
      checkCaseApprove(){

          let returnVal = false;
      
      //(checkProperty( item ,'data' , 'category')== 'CASE_APPROVED' && checkProperty( item ,'status'))
        let category =  this.checkProperty( this.item ,"data" , "category")
          if(this.item.status && category =="CASE_APPROVED"){
              returnVal = true;
          }
          return returnVal;

      },
      
      checkApproveDoc(){

          let returnVal = false;
      
        //(checkProperty( item ,'data' , 'category')== 'APPROVED_BY_DOC_MANAGER' && checkProperty( item ,'status'))
        let category =  this.checkProperty( this.item ,"data" , "category")
          if(this.item.status && category =="APPROVED_BY_DOC_MANAGER"){
              returnVal = true;
          }
          return returnVal;

      },
      
       //REQUEST_PETITIONER_SIGN
      checkRequestForSignin(){

          let returnVal = false;
      
     //checkProperty( item ,'data' , 'category')== 'REQUEST_PETITIONER_SIGN' && checkProperty( item ,'status')
        
        let category =  this.checkProperty( this.item ,"data" , "category")
          if(this.item.status && category =="REQUEST_PETITIONER_SIGN"){
              returnVal = true;
          }
          return returnVal;

      },
      //SUBMIT_TO_USCIS
      checkSubmitToUSCIS(){

          let returnVal = false;
     // checkProperty( item ,'data' , 'category')== 'SUBMIT_TO_USCIS' && checkProperty( item ,'status')
        
        let category =  this.checkProperty( this.item ,"data" , "category")
          if(this.item.status && category =="SUBMIT_TO_USCIS"){
              returnVal = true;
          }
          return returnVal;

      },
      checkTenantCreated(){

          let returnVal = false;
      
        //(checkProperty( item ,'data' , 'category')== 'TENANT_CREATED' && checkProperty( item ,'status'))
        let category =  this.checkProperty( this.item ,"data" , "category")
          if(this.item.status && category =="TENANT_CREATED"){
              returnVal = true;
          }
          return returnVal;

      },
      //COURIER_TRACKING
      checkCourierTrackingTodo(){

          let returnVal = false;
      
        //(['UPDATE_USCIS_RECEIPT_NUMBER' ,'COURIER_TRACKING'].indexOf(checkProperty( item ,'data' , 'category'))>-1 && checkProperty( item ,'status'))
        let category =  this.checkProperty( this.item ,"data" , "category")
          if(this.item.status && (category =="COURIER_TRACKING" || category=='UPDATE_USCIS_RECEIPT_NUMBER' )){
              returnVal = true;
          }
          return returnVal;

      },
      //
      checkUpdateUscisResponseTodo(){

          let returnVal = false;
      
        //(['UPDATE_USCIS_RESPONSE'].indexOf(checkProperty( item ,'data' , 'category'))>-1 && checkProperty( item ,'status'))
        let category =  this.checkProperty( this.item ,"data" , "category")
          if(this.item.status && (category =="UPDATE_USCIS_RESPONSE"  )){
              returnVal = true;
          }
          return returnVal;

      },
     checkNewCompanyCreated(){

          let returnVal = false;
      
        //(['COMPANY_CREATED'].indexOf(checkProperty( item ,'data' , 'category'))>-1 && checkProperty( item ,'status'))
        let category =  this.checkProperty( this.item ,"data" , "category")
          if(this.item.status && (category =="COMPANY_CREATED"  )){
              returnVal = true;
          }
          return returnVal;

      },
      checkActionIsRequited(){
          let returnVal = false;
      
         // checke petitoon Todos
        // (petitionToDoList.indexOf(checkProperty( item ,'data' , 'category')) >-1 && checkProperty( item ,'status' ))
        let category =  this.checkProperty( this.item ,"data" , "category")
          if(this.item.status && this.petitionToDoList.indexOf(category) >-1){
              returnVal = true;
          }
          return returnVal;
      },
      */
      getPetitionerRoleName(item){

        if(this.checkProperty(this.userRolelist ,'length')>0){
          //userRolelist
          let petitioner = _.find( this.userRolelist ,{"id": 50});
          if(this.checkProperty(petitioner ,'name')){

            return petitioner['name'];
          }else{
            return "Petitioner";

          }

        }else{
          return "Petitioner";
        }
      },
      addReviewrsRolesList(){

        let reviewrsRolesList =[]
          
          let tempData = _.cloneDeep(this.usersList);
          let tempUnuqueItems =[]
          _.forEach(tempData ,(object)=>{
            if(tempUnuqueItems.indexOf(object['roleName']) <=-1){
              tempUnuqueItems.push(object['roleName']);
              reviewrsRolesList.push(object); 

            }

          })
          return reviewrsRolesList;
  
        
      },

     /*** Computed ***/

     openSetCaseCodePopup(){
         
         this.formerrors = null;
         this.newCaseCode = this.checkProperty( this.item,'data' ,'caseNo');
         this.confCaseCode = '';
         this.settingCaseNumber =false
         this.$validator.reset('newCaseNumberForm')
         this.setCode = true;
      },
       SetCaseCodeAction() {
       
      this.$validator.validateAll('newCaseNumberForm').then((result) => {
        
        if (result) {
           
           let self =this;
          let postData = {
            caseNo: self.newCaseCode.trim(),
            //currentPassword: self.confCaseCode,
             petitionId: self.petitionDetails['_id'],
             subTypeName:self.checkProperty(self.petitionDetails,'subTypeDetails','name'),
             typeName:self.checkProperty(self.petitionDetails,'typeDetails','name'),
         
          };
          let path = "/petition/assign-custom-caseno";
          if(self.checkProperty(self.petitionDetails,'subTypeDetails','id') ==15){
            path = "/perm/assign-custom-caseno";
          }
           this.settingCaseNumber =true;
           
            this.$store.dispatch("commonAction", {"data":postData ,"path":path})
              .then(response => {
                   this.showToster({message:response.message,isError:false });
                   this.newCaseCode ='';
                  this.confCaseCode ='';
                  this.$validator.reset('newCaseNumberForm');
                  this.setCode = false;
                   this.settingCaseNumber =false
                    this.reloadWallList();
                  
              }).catch((err)=>{
                 this.settingCaseNumber =false
                 this.formerrors =err
               // this.showToster({message:err,isError:true });
              });
        }
      });
     },

    getlableName(){
      let self =this;
     let code = self.checkProperty( this.item ,"data" , "category");
       let returnValue = "Submit to Reviewer";

      let labels = [
        {"code":"ASSIGN_SUPERVISOR" ,"label":"Assign Supervisor"},
        {"code":"ASSIGN_PARALEGAL" ,"label":"Assign Paralegal"},
        {"code":"ASSIGN_DOCUMENTATION_MANAGER" ,"label":"Assign Document Manager"},
        {"code":"ASSIGN_DOCUMENTATION_EXECUTIVE" ,"label":"Assign Document Executive"},
       {"code":"ASSIGN_ATTORNEY" ,"label":"Assign Attorney"},
      ];

      let assignLabel = _.find(labels , {"code":code} );
     
      if(assignLabel && this.checkProperty(assignLabel ,'label' )){

        returnValue = assignLabel['label'];

      }  else if(this.lableData.length>0 && code){
        let msgObject = _.find(this.lableData , {"code":code});
        if( msgObject && _.has(msgObject , 'actionLable')){
            returnValue = msgObject['actionLable'];
        }

      }

      return returnValue;

    },
    getBorderColor(){
     let returnValue =``;
        if(this.checkProperty(this.item ,"data" ,"config")){
          let config = this.item['data']['config'];
          if( this.checkProperty( config ,'bgColor' ,"length")>1 ){
             let color1 = config['bgColor'][0]
             let color2 = config['bgColor'][1]
            returnValue =`1px solid ${color2}`;
          }
        }
        return returnValue;
    },
    getGredieantColor(wallItem){
      let angle =118
        let color1 = '#EFF7FF'
        let color2 = '#DEEAF6'
      let returnValue =`linear-gradient(${angle}deg, ${color1} 0%, ${color2}  100%)`;
      if(this.checkProperty(wallItem ,"data" ,"config")){
        let config = wallItem['data']['config'];
        if( this.checkProperty( config ,'bgColor' ,"length")>0 ){
          //  returnValue =config['bgColor'][0];
        // return 'linear-gradient(118deg, '+config['bgColor'][0]+' 0%,'+ config['bgColor'][1]+' 100%);'
         angle =118
         color1 = config['bgColor'][0]
         //color2 = config['bgColor'][1];
         returnValue =  color1
        //  returnValue= `linear-gradient(${angle}deg, ${color1} 0%, ${color2}  100%)`;
        }
      }
      return  returnValue;
    },
    addClass(){
      this.isAddcls =true;
    },
     openDocumentsPopup(){
       this.documentsViewPopup =true;
     },
     fetchWorkflowDetails(callBack=null){
    
   
    this.workFlowDetails = null;
    let category =  this.checkProperty( this.item ,"data" , "category")
            
    if(this.checkProperty( this.petitionDetails ,'workflowId') && _.has(this.assignMentUsersList ,category)){
      let payLoad = {"path":"/workflow/details",data:{'workflowId':this.checkProperty( this.petitionDetails ,'workflowId')}};
      this.$store.dispatch("commonAction" ,payLoad)
      .then((res)=>{
        this.workFlowDetails = res;
        this.findSkipedActivityList();
          this.$vs.loading.close();
       
        
        let currentActivityList = this.assignMentUsersList[category];
       
        if( this.workFlowDetails &&  _.has(this.workFlowDetails ,'config') ){
           let usersListObject = _.find(this.workFlowDetails['config'] ,{"code":currentActivityList});
          this.usersList =[];
          let postData ={
              "matcher":{
              "roleIds": [],
              "branchId":"",
              },
              
              "page": 1,	
              "perpage":100000000,
              
              };

          let companyIdRoles =[50 ,51];
          let branchIdRoles =[4, 5, 6, 7, 8, 9, 10, 11 ,12];
          _.forEach(usersListObject['editors'],(editor)=>{
          
          
          postData.matcher.roleIds.push(editor.roleId);
          if(companyIdRoles.indexOf(editor.roleId)>-1 && this.checkProperty(this.petitionDetails ,'companyDetails' ,'_id')){
              postData = Object.assign(postData ,{"companyId":this.checkProperty(this.petitionDetails ,'companyDetails' ,'_id') })
          }

          if(branchIdRoles.indexOf(editor.roleId)>-1 && this.checkProperty(this.petitionDetails ,'branchId')){
              postData['matcher']['branchId'] = this.checkProperty(this.petitionDetails ,'branchId');
          }
          

          });
          //alert(JSON.stringify(postData));

          this.$store.dispatch("getList",{data:postData ,path:'/petition/assign-user-list'} ).then(response => {
          //alert(JSON.stringify(response.list));
              let lst = []
              
              _.forEach(response.list ,(item)=>{
                  if(_.has(item ,'name') && _.has(item ,'roleName') && ( item._id !=this.getUserData['userId'])){
                      item.name = item.name+" ("+item.roleName+")";
                      lst.push(item);
                  }
              
              });
              this.usersList = lst;
              if(callBack){
              callBack();
              }
            
          });
              
        }
        
       
             
      })
      .catch((error)=>{
       
           this.workFlowDetails = null;
             this.$vs.loading.close();
                  
        
      })

    }else{
        this.$vs.loading.close();
    }

    },
     findSkipedActivityList(){
      
      this.skipedActivityList =[];
       this.skipedActivity =false;
      let workFlowDetails =  this.workFlowDetails;
    if(workFlowDetails && this.petitionDetails && this.checkProperty(this.petitionDetails , 'nextWorkflowActivity') && _.has(workFlowDetails ,"config")){
        
         let config  = workFlowDetails['config'];
       let petitionCurrentActivityIndex = _.findIndex(config ,{"code": this.petitionDetails['nextWorkflowActivity'] });
       let completedActivityList = this.petitionDetails['completedActivities'];
      
       if(petitionCurrentActivityIndex>-1 && completedActivityList.length>0  && (completedActivityList.indexOf("SUBMIT_TO_USCIS")<=-1 ) ){
      
        _.forEach(config ,(activityItem ,index)=>{
          if(index<petitionCurrentActivityIndex){
            
            if(completedActivityList.indexOf(activityItem['code'])<=-1   && _.has(this.assignMentUsersList ,activityItem['code'])){
              
            
             if(completedActivityList.indexOf("CASE_APPROVED") >-1){

                if([ 'ASSIGN_DOCUMENTATION_MANAGER','ASSIGN_DOCUMENTATION_EXECUTIVE'].indexOf(activityItem['code']) >-1){

                     this.skipedActivityList.push(activityItem['code']);
                     this.skipedActivity =true;

                }

              }else{
                this.skipedActivityList.push(activityItem['code']);
                this.skipedActivity =true;

              }
              
              
            
            
            }

          }


        })
       }
            
    }
   

    },
      reloadWallList(){

           setTimeout(() => {
                   this.loading =false;
                   this.$emit("reloadWals");
                   
                } ,100)

      },
      goToDetaillPage(){
        //alert(this.checkProperty(this.item ,'data' ,'navigationKey'))
          //alert( this.checkProperty(this.item ,'data' ,'navigationKey'))
          let category = this.checkProperty( this.item ,"data" , "category");

           if( this.checkProperty(this.item ,'data' ,'navigationKey')  == "TASK_DETAILS"){

               let taskId = this.checkProperty(this.item ,"data", "taskId");
                let path =  {'path':"/tasks-list" ,"query":{}};
               if(taskId) {
                 path["query"]['id'] =taskId
                 this.$router.push(path);

               }
                


          }

          if( this.checkProperty(this.item ,'data' ,'navigationKey')  == "TENANT_DETAILS"){

               let tenantId = this.checkProperty(this.item ,"data", "tenantId");
               if(tenantId) this.$router.push("/customer-details/"+tenantId);


          }
          if((this.checkProperty(this.item ,'data' ,'navigationKey')=='LCA_DETAILS') ){
              let petitionId = this.checkProperty( this.item ,"data" , "petitionId");
              if(petitionId){
                 
                   this.$store.dispatch("setPetitionTab" , 'set_LCA');
                  this.findDetailsPage(petitionId);
                 
                

              }
                 

          }else if(this.petitionToDoList.indexOf(category)>-1  ||  this.checkProperty(this.item ,'data' ,'navigationKey') =='PETITION_DETAILS'   ){
              let petitionId = this.checkProperty( this.item ,"data" , "petitionId");
              if(petitionId){
               
                 this.findDetailsPage(petitionId);
               
                

              }
                 

            }else if( this.tenantTodoList.indexOf(category)>-1 || ['TENANT_STATUS_UPDATE'].indexOf(category)>-1){

               let tenantId = this.checkProperty(this.item ,"data", "tenantId");
               if(tenantId)
                  this.$router.push("/customer-details/"+tenantId);
          }else if( this.checkProperty(this.item ,'data' ,'navigationKey')=='USER_DETAILS'){

              this.$router.push("/users");
          }
          else if( this.checkProperty(this.item ,'data' ,'navigationKey')=='COMPANY_DETAILS'){
           
              let companyId = this.checkProperty(this.item ,"data", "companyId")
              if(companyId)
                 this.$router.push("/petitioner-details/"+companyId);
          }else if( ['TICKET_DETAILS'].indexOf(this.checkProperty(this.item ,'data' ,'navigationKey'))>-1){
           
              let ticketId = this.checkProperty(this.item ,"data", "ticketId");
              if(ticketId)
                 this.$router.push("/ticket-details/"+ticketId);
          }
          
      },
      fetchPetitionDetails(wallItem,callBack ,funName=''){
           this.item = wallItem
          let category =  this.checkProperty( this.item ,"data" , "category")
        
          if( this.petitionToDoList.indexOf(category)>-1 ||  this.checkProperty(this.item ,'data' ,'navigationKey') =='PETITION_DETAILS'){
         
           this.$vs.loading();
               let petitionId = this.checkProperty( this.item ,"data" , "petitionId");
            this.$store.dispatch("getpetition", petitionId).then(response => {
               
                if (response.data) {


                  
                    this.petitionDetails = response.data.result;
                     if(funName=="openApproveOrRejectDocs"){
                       callBack()
                    }
                     if(funName=="openapproveCasePopup"){
                       callBack()
                    }
                    //updateUSCISstatus
                    if(funName=="updateUSCISstatus"){
                       callBack()
                    }
                    if(funName =='openSetCaseCodePopup'){
                      this.openSetCaseCodePopup();
                       this.$vs.loading.close();
                      return false
                    }
                    
                    if(_.has(this.assignMentUsersList ,category)){
                      this.fetchWorkflowDetails(callBack);
                    }else if(category=='REQUEST_PETITIONER_SIGN' || category == 'SUBMIT_TO_USCIS'){
                       this.getFormsAndLetters(callBack);
                         this.$vs.loading.close();
                    }else  if((['UPDATE_USCIS_RECEIPT_NUMBER' ,'COURIER_TRACKING'].indexOf(this.checkProperty( this.item ,'data' , 'category'))>-1 && this.checkProperty( this.item ,'status'))){
                       
                      this.getCourierList(callBack);
                    }else{
                         this.$vs.loading.close();
                    }
                   
                  
               }else{
                   this.$vs.loading.close();

               }
            })
            
          }else if( this.tenantTodoList.indexOf(category)>-1){
           
            this.getTenantDetails();

          }else if( ['COMPANY_CREATED'].indexOf(category)>-1){
            this.getpetetioner();

          }
         
      },
      submitAction(action=''){
          this.$validator.validateAll("assignmentForm").then((result) => {
            if (result) {
              let postData = {
               petitionId: this.petitionDetails['_id'],
                comment: this.comments,
                  "userId": this.checkProperty(this.selectedUser ,"_id"),
                  "userName": this.checkProperty(this.selectedUser ,"name"),
                  "roleId":  this.checkProperty(this.selectedUser ,"roleId"),
                  "assignRoleName":  this.checkProperty(this.selectedUser ,"roleName"),
                  subTypeName:this.checkProperty(this.petitionDetails,'subTypeDetails','name'),
                  typeName:this.checkProperty(this.petitionDetails,'typeDetails','name'),
                   "action":this.checkProperty( this.item ,"data" , "category"), //"ASSIGN_SUPERVISOR", // "ASSIGN_PARALEGAL" / "ASSIGN_DOCUMENTATION_MANAGER" / "ASSIGN_DOCUMENTATION_EXECUTIVE" / "ASSIGN_ATTORNEY"
                 // "lastUserName": "Paralegal", // is Required when replacing a paralegal(action == "REPLACE_PARALEGAL"),
                //  "submitted": true // Required only when submitting to any roleSupervisor
                 isSkippedAction:this.skipedActivity?true:false

              };
              
              
             
               this.loading =true;
               this.$store
              .dispatch("commonAction", {"data":postData ,"path":"/petition/assign-a-role"})
              .then(response => {
                this.showPopup =false;
             
                this.showToster({message:response.message,isError:false });
                this.skipedActivity =false;
                this.reloadWallList();

                
                
                
                                
              })
              .catch((error)=>{
                
                this.formErrors =error;
                this.loading =false;
              })
              
       
       

              
            }
          });
      

      },
      openPopup(){
     
         this.formErrors = '';
        this.comments ='';
      
       // if(this.usersList.length>0){
          this.formErrors ="";
          this.comments ='';
          this.showPopup =true;
          this.selectedUser =null;
          this.loading =false;
          if(this.checkProperty(this.petitionDetails ,'typeDetails' ,'name') && this.checkProperty(this.petitionDetails ,'subTypeDetails' ,'name')){
            this.comments = "Case "+this.petitionDetails.typeDetails.name+", "+this.petitionDetails.subTypeDetails.name+"  is being assigned for further actions";

          }
           
        // }else{
        //   this.showToster({message:'Reviewers not found.',isError:true });
         
        // }
          

    

       
      this.$validator.reset();
      
      
     

    },
    selectUesr(item){
      this.selectedUser = item;
     
    },

    //CASE APPROVE Section
      openapproveCasePopup(){
         
          if (this.checkProperty(this.petitionDetails ,'lcaId')!= null && this.checkProperty(this.petitionDetails ,'lcaId')!= '') {
               this.$vs.loading();
                    this.$store
                        .dispatch("fetchLcaDetails", this.petitionDetails.lcaId)
                        .then(response => {
                              this.$vs.loading.close();
                            this.lcaDetails = response.data.result;
                            let getLcaDetails = _.cloneDeep(this.lcaDetails);
                             if( getLcaDetails && _.has(getLcaDetails ,"statusId") ){
                                    if( [2,3].indexOf(getLcaDetails['statusId'])<=-1 ){
                                        this.showToster({message:"LCA should be either Filed or Certified in order to approve the case." ,isError: true});
                                        setTimeout(() => {
                                                this.loading =false;
                                                    this.goToDetaillPage();
                                                
                                                } ,100)
                                        
                                        return false;
                                    }else{
                                        this.showPopup =false;
                                        this.formErrors = '';
                                        this.comments ='';
                                        this.loading =false,
                                        this.approveCasePopup =true;
                                        this.$validator.reset();

                                    }
                             }


                        }).catch((err)=>{
                             this.$vs.loading.close();
                             this.showToster({message:err ,isError: true});
                            setTimeout(() => {
                                    this.loading =false;
                                        this.fetchPetitionDetails(this.item);
                                    
                                    } ,100)
                        })
          }else{
               this.showPopup =false;
                this.formErrors = '';
                this.comments ='';
                this.loading =false,
                this.approveCasePopup =true;
                this.$validator.reset();

          }                
      
       


     },
    caseApproveCaseAction(){
       this.formErrors ='';
         let postData = {
             petitionId: this.petitionDetails['_id'],
            comment: this.comments,
            action:'CASE_APPROVED', // "SUBMIT_TO_LAW_FIRM", // "CASE_APPROVED" / "LCA_CERTIFIED_FOR_PETITION" / "SUBMIT_TO_USCIS" / "USCIS_APPROVED" / "USCIS_RECEIVED_RFE" / "USCIS_DENIED" 
            today: moment().format('YYYY-MM-DD'), // Required on Status changes to "Received RFE"
           subTypeName:this.checkProperty(this.petitionDetails,'subTypeDetails','name'),
           typeName:this.checkProperty(this.petitionDetails,'typeDetails','name'),

         };
         
         this.$validator.validateAll("approvecase").then((result) => {
           
            if (result) {
               this.loading =true;
               this.$store
              .dispatch("commonAction", {"data":postData ,"path":"/petition/manage-approval-process"})
              .then(response => {
                
                 this.showToster({message:response.message,isError:false });
                 this.showPopup =false;
                 this.approveCasePopup =false;
                  this.loading =false;
                  this.reloadWallList();
                
                
                                
              })
              .catch((error)=>{
                 this.loading =false;
                this.formErrors =error;
              })
       
       

              
            }
          });
           

       
     

    },

//Approve reject Documents
     openApproveOrRejectDocs(){
     
     this.formErrors = '';
        this.comments ='';
         this.loading =false;
         this.approveOrRejectDocs = true;
     this.$validator.reset();
  },
  approveOrRejectDocsAction(action=""){
    this.formErrors ="";
     this.$validator.validateAll("approveOrRejectDocsForm").then(result => {
      if(result && ['APPROVED_BY_DOC_MANAGER', 'REJECT_BY_DOC_MANAGER'].lastIndexOf(action)>-1){
        var postData = {
              petitionId:this.checkProperty(this.petitionDetails,'_id'),
              typeName:this.checkProperty(this.petitionDetails,'typeDetails','name'),
              subTypeName:this.checkProperty(this.petitionDetails,'subTypeDetails','name'),
              comment:this.comments, // Required on APPROVED_BY_DOC_MANAGER and REJECT_BY_DOC_MANAGER
              action: action,//"UPLOAD_BY_DOC_EXECUTIVE",//APPROVED_BY_DOC_MANAGER, REJECT_BY_DOC_MANAGER
              today: moment().format("YYYY-MM-DD")
        }

        this.loading =true;
        this.$store.dispatch("commonAction", {"data":postData ,"path":"/petition/manage-offshore-document-upload"})
              .then((response) => {
              
             
              this.approveOrRejectDocs = false;
              this.showToster({message:response.message,isError:false })
               this.reloadWallList();
              
                            
              })
              .catch((error) => {
              
                this.formErrors = error;
                this.loading = false;
                
              
              })
       }
            
         
     })
   
  },

  //tenant related ToDo 
  getTenantDetails(){
    let tenantId = this.checkProperty(this.item ,"data", "tenantId")
          let postData = {tenantId:tenantId};
            this.$vs.loading();
           this.$store.dispatch("commonAction", {"data":postData ,"path":"/tenant/details"})
           .then((response) => {
               this.tenantDetails =response;
               this.$vs.loading.close();
           })
           .catch((err) =>{
               this.$vs.loading.close();
                this.tenantDetails =null;
               this.showToster({message:err,isError:true });

           })



  },
  openTenantApprovepopup(status=2 ,txt='', event){
  
        this.getTenantDetails()
        this.tntActionText = "Do you want to "+txt+" ?",
        this.popuptntTxt = txt;
        this.selectedtenantStatus = status;
        this.approveTenantConformpopUp =true;
        this.formErrors = '';
        this.comments ='';
         this.loading =false;

  },
  changetenantStatus( ){
        let post_data = {"tenantId":this.tenantDetails['_id'], "statusId":this.selectedtenantStatus }
      
      let action ="changetenantStatus"
       if(this.selectedtenantStatus ==4){
        action = "deleteTenant"
       }
       if( this.comments.trim() =='' && [3,4,5].indexOf(this.selectedtenantStatus)>-1 ){
         return true;

       }
       if([3,4,5].indexOf(this.selectedtenantStatus)>-1){
        post_data = Object.assign(post_data,{"comment":this.comments}) ;
       }
       //alert(action)
       this.$store.dispatch(action, post_data)
          .then(response => {
            this.showToster({message:response.message,isError:false});
            this.approveTenantConformpopUp =false;
            this.reloadWallList();


          }).catch((err)=>{
            this.formErrors = err;
            this.showToster({message:err,isError:true});
          
        });
 },

 //Request for signin documents

  getFormsAndLetters(callBack=null){
    this.formsAndLettersList = [];
    let finalList =[];
      let postData ={petitionId:this.petitionDetails._id ,'page':1 ,'perpage':10000 };
    this.$store.dispatch("getList" ,
    {
      data:postData,
      //path:"/petition/filled-forms-and-letters-list"
      path:"/filled-forms-and-letters/list"
    })
    .then(response => {
  //  this.formsAndLettersList = response.list;

    
      let lst = [];
    
    _.forEach(response.list ,(mainItem)=>{
        mainItem = Object.assign(mainItem,{"reverse_document_versions":[] ,"mainParentId":'',showMe:true ,"selectedForSigning":false});
        if(mainItem.parentId){
            mainItem['mainParentId'] = mainItem['parentId']
        }else{
            mainItem['mainParentId'] = mainItem['_id']
        }

        lst.push(mainItem);
          

    });

    let subList=[];
    
    //reverse_document_versions
    _.forEach(lst ,(mainItem)=>{

                        
        
        _.forEach(lst ,(subItem)=>{
            if( mainItem.parentId && (mainItem.parentId == subItem['parentId'] ||  mainItem.parentId == subItem['_id']   ) &&  mainItem['_id'] != subItem['_id']){
                      
                      subItem['showMe'] =false;
                      if(subList.indexOf(subItem['_id']<=-1)){
                          mainItem['reverse_document_versions'].push(subItem);
                          subList.push(subItem['_id']);

                      }
                    
                    // mainItem['showMe'] =true;
            }

        })
        
    if(mainItem.showMe){
          finalList.push(mainItem);
    }
        

    })
    


    this.formsAndLettersList =  finalList;
    if(callBack){
      callBack();
    }
  })

  },

  selectFormsandLatters(index ,forms){
  if( !this.formsAndLettersList[index]['selectedForSigning'] ){
    
    forms['selectedForSigning'] =true;
    this.formsAndLettersList[index]['selectedForSigning'] = true
  }else{
      forms['selectedForSigning'] =false;
    this.formsAndLetters[index]['selectedForSigning'] = false;
  }



  // alert(this.petition.formsAndLetters[index]['selectedForSigning']);

  },
  submitpetitionrequest() {

  this.$validator.validateAll().then((result) => {
      this.requestsignCommentError =false;
    if(this.comments =='' || this.comments.trim() =='' ){
        this.requestsignCommentError =true;
      
    }
    
    
    if (result) {
        var postdata = {
            petitionId: this.petitionDetails._id,
            comment: this.comments,
            subTypeName:this.checkProperty(this.petitionDetails,'subTypeDetails','name'),
            typeName:this.checkProperty(this.petitionDetails,'typeDetails','name'),
            "formsAndLetters":[],
             "notifyPetitioner":false,
                "emailDocsForSign":false,  
        };
        _.forEach(this.formsAndLettersList ,(item)=>{
          if(item['selectedForSigning']){
            postdata['formsAndLetters'].push(item['_id']);
          }

        })

         postdata['notifyPetitioner'] = this.notifyPetitioner
         postdata['emailDocsForSign'] = this.emailDocsForSign
    
        if(postdata['formsAndLetters'].length >0) {
          this.loading =true;
          this.$store.dispatch("requestforsign", postdata).then((response) => {
            
            this.requestsignCommentError =false;
              this.showToster({ message: response.message, isError: false });
            this.requestsignPopup = false;
            this.reloadWallList();
            
          }) .catch((error) => {
              this.formErrors = error;
              this.showToster({ message: error, isError: true });
              this.requestsignCommentError =true;
              this.loading =false;
          });

        }else{
            this.formErrors ='';
            this.loading =false;
           this.checkFormsandLatters=true;
        }
        
    }
  });
        
    },
    
  showPetitionersign() {

      this.formErrors ="";
      this.comments ='';
      this.loading =false;
      this.notifyPetitioner =true;
      this.emailDocsForSign =false;
      this.requestsignCommentError = false;
    
      this.$validator.reset();
  let formsAndLettersActiveList = _.filter(this.formsAndLettersList ,{ "statusId":2})
  if(this.formsAndLettersList.length>0 && formsAndLettersActiveList.length>0){
      this.requestsignPopup = true;
    

  }else{
    this.showToster({ message: "Required at least one forms and letters documents to send for signature.", isError: true });
    setTimeout(() => {
      this.goToDetaillPage();
    },100)
    
    
  }
        
    }, 

  //Submit to uscis  
  getscannedCopiesList(){
           this.formErrors ='';
             this.loading =false;
             this.comments ='';
          this.scannedCopies =[];
            let finalList =[];
          let postData ={petitionId:this.petitionDetails['_id'] ,'page':1 ,'perpage':100000};
        this.$store.dispatch("getList" ,{data:postData,path:"/petition/scanned-copies-list"})
        .then(response => {
            
        let lst = [];
        
        _.forEach(response.list ,(mainItem)=>{
            mainItem = Object.assign(mainItem,{"reverse_document_versions":[] ,"mainParentId":'',showMe:true ,selectedForDownload:false});
            if(mainItem.parentId){
                mainItem['mainParentId'] = mainItem['parentId']
            }else{
                mainItem['mainParentId'] = mainItem['_id']
            }

            lst.push(mainItem);
              

        });

        let subList=[];
        
        //reverse_document_versions
        _.forEach(lst ,(mainItem)=>{

                            
            
            _.forEach(lst ,(subItem)=>{
                if( mainItem.parentId && (mainItem.parentId == subItem['parentId'] ||  mainItem.parentId == subItem['_id']   ) &&  mainItem['_id'] != subItem['_id']){
                          
                          subItem['showMe'] =false;
                          if(subList.indexOf(subItem['_id']<=-1)){
                              mainItem['reverse_document_versions'].push(subItem);
                              subList.push(subItem['_id']);

                          }
                        
                        // mainItem['showMe'] =true;
                }

            })
            
        if(mainItem.showMe){
              finalList.push(mainItem);
        }
        

          
          

        })
        

        
        this.scannedCopies =  finalList;
        if(this.scannedCopies.length > 0){
          this.submiTouscisPopup = true;
           this.$validator.reset();

        }else{
            this.submiTouscisPopup = true;
           // this.showToster({message:"Scanned Documents are not uploaded" ,isError:true});
          
             // this.goToDetaillPage();
        
          

        }
        
        
        
        }).catch((err)=>{
            this.submiTouscisPopup = true; 
              this.scannedCopies =[];
          //  this.showToster({message:"Scanned Documents are not uploaded" ,isError:true});
            //  this.goToDetaillPage();
        
            
        })

        
        

  },

  submitToUscisAction(){
        this.formErrors ='';
         let postData = {
             petitionId: this.petitionDetails['_id'],
            comment: this.comments,
            action:'SUBMIT_TO_USCIS', // "SUBMIT_TO_LAW_FIRM", // "CASE_APPROVED" / "LCA_CERTIFIED_FOR_PETITION" / "SUBMIT_TO_USCIS" / "USCIS_APPROVED" / "USCIS_RECEIVED_RFE" / "USCIS_DENIED" 
            today: moment().format('YYYY-MM-DD'), // Required on Status changes to "Received RFE"
           subTypeName:this.checkProperty(this.petitionDetails,'subTypeDetails','name'),
           typeName:this.checkProperty(this.petitionDetails,'typeDetails','name'),

         };
        
         this.$validator.validateAll("activityfoform").then((result) => {
            if (result) {
               this.loading =true;
               this.$store
              .dispatch("commonAction", {"data":postData ,"path":"/petition/manage-approval-process"})
              .then(response => {
                 this.loading =false;
                 this.showToster({message:response.message,isError:false });
                 this.submiTouscisPopup =false;
                 this.reloadWallList()
                
                
                                
              })
              .catch((error)=>{
                this.loading =false;
                this.formErrors =error;
              })
       
       

              
            }
          });
           

       

    },

    //Courier Tracking
    updateTrackingDetails() {
        // this.$vs.loading();
         this.$vs.loading.close();
        this.updateTrackingPopup = false;
        this.formErrors ='';
        this.loading =false;
        this.filesAreuploading =false;
        this.tracking.trackingId ='';

        this.tracking.documents = [];
        this.uscisdocument = [];
        this.trackingdoc = [];
        
          if(!(_.has(this.petitionDetails , 'courierTrackingCategory')) || (  _.has(this.petitionDetails , 'courierTrackingCategory') && !this.petitionDetails['courierTrackingCategory'] )){
          //petition.courierTrackingCategory
          //this.tracking['courier'] =null;
          // this.tracking['trackingId'] ='';
        }

        if(["COURIER_TRACKING" , 'UPDATE_USCIS_RECEIPT_NUMBER'].indexOf(this.petitionDetails.nextWorkflowActivity)>-1){
          this.updateTrackingPopup = true;
        }
       //  this.$vs.loading.close();
        
          
    }, 
    changedCourier() {
    if(_.has(this.tracking ,'courier') && (_.has(this.tracking['courier'] ,'code')) ){

    this.tracking = Object.assign(this.tracking ,{'courierCode':this.tracking["courier"]["code"] });

    }
    if(_.has(this.tracking ,'courier') && (_.has(this.tracking['courier'] ,'track_url')) ){

    this.tracking = Object.assign(this.tracking ,{"trackingUrl":this.tracking["courier"]["track_url"]  });

    }

          
        // this.tracking.trackingUrl = this.tracking["courier"]["code"];
        // this.tracking.courierCode = this.tracking["courier"]["code"];
    },
    updateTracking() {

    //this.petition.nextWorkflowActivity
          this.formErrors ='';
        this.loading =false;
        this.$validator.validateAll("trackingform").then((result) => {
            if (result) {
                this.tracking.petitionId = this.petitionDetails._id;
                this.tracking.action =
                    this.petitionDetails.courierTrackingCategory != "UPDATE_TRACKING_NUMBER" ?
                    "UPDATE_TRACKING_NUMBER" :
                    "UPDATE_USCIS_RECEIPT_NUMBER";
                
                this.tracking.action =this.petitionDetails.nextWorkflowActivity;
              
                if(this.trackingdoc && this.trackingdoc.length>0){
                    this.tracking = Object.assign(this.tracking,{"documents":this.trackingdoc});
                }
                

                  let tracking = _.cloneDeep(this.tracking);
                if(_.has(tracking , "courier")){

                    let courier = _.cloneDeep(tracking['courier'] );
                    if((_.has(courier  , "name"))){
                      tracking = Object.assign( tracking , { 'courier':courier['name'] });
                    }
                    if((_.has(courier  , "code"))){
                      tracking = Object.assign( tracking , { 'courierCode':courier['code'] });
                    }
                }

              this.loading =true;
           
                this.$store
                    .dispatch("updateTrackingDetails", tracking)
                    .then((response) => {
                        
                          this.formErrors ='';
                        this.showToster({ message: response.message, isError: false });
                          this.loading =false;
                        this.updateTrackingPopup = false;
                        this.reloadWallList();
                        
                    })
                    .catch((error)=>{
                        this.formErrors =error;
                      this.loading =false;
                      //this.showToster({ message: error, isError: true });

                    });

            }

        })

    },
     getCourierList(callBack=null) {
      let postdata = {};

      this.$store.dispatch("getCourierList", postdata).then((response) => {
       // alert(JSON.stringify(response))
        
        //this.courierList = response;
      });
      //tracking/list
       this.$store.dispatch("getList",{data:postdata ,path:'/tracking/courierlist'} ).then(response => {
        if(this.checkProperty(response , "list")){
          this.courierList = response.list;
        }
          if(callBack){
          callBack();
          }
        
        
      });

    },
    selectedDocuments(index, fls) {
      let docs = _.cloneDeep(fls)

      docs = docs.map(
          (item) =>
          (item = {
              name: item.name,
              file: item.file,
              url: "",
              path: "",
              mimetype: item.type,
              documentType:item.documentType?item.documentType:null
          })
      );
      
      if (docs.length > 0) {
          var self = this;
          this.filesAreuploading = true;
          let count =0;
          docs.forEach(function (doc) {
              let formData = new FormData();
              formData.append("files", doc.file);
              formData.append("secureType", "private");
              self.$store.dispatch("uploadS3File", formData).then((response) => {
                count = count+1;
                  if (response.data && response.data.result) {
                      response.data.result.forEach((urlGenerated) => {
                          doc.url = urlGenerated;
                            doc.path = urlGenerated;
                          delete doc.file;
                          self.tracking.documents = docs;
                          self.uscisdocument = docs;
                          self.trackingdoc = docs;
                          
                          
                              
                            if(parseInt(count)>=docs.length){
                              self.filesAreuploading = false;
                            

                          }
                      });
                      if(count>=docs.length){
                        self.filesAreuploading = false;

                      }
                      
                  }
                  
              });
          });
      }
    },
     remove(item, type) {
        let doc=type[item]
        type.splice(type.indexOf(item), 1);
        this.removeFileFromS3(doc)
        return false;
    },
    fileNameChenged(fl) {
            let fname = fl["name"];
            fname = fname.trim();
            this.isInvaliedFileName = false;
            if (!fname) {
                this.isInvaliedFileName = true;
            }
        },

    ///updateUSCISstatus

    updateUSCISstatus(){

       this.casestatus =null;
       this.uscisdocument =[];
      this.dueDate =null;
      this.receivedDate =null;
	    this.issuedDate =null;

       this.filesAreuploading =false;
            
            this.comments='';
            this.formErrors='';
            this.loading =false;
            this.updateUSCISstatusPopup = false;

            //UPDATE_USCIS_RESPONSE
        if(["UPDATE_USCIS_RESPONSE" ,].indexOf(this.petitionDetails.nextWorkflowActivity)>-1){
        this.updateUSCISstatusPopup = true;
        }

    },
    petitionApproval() {
            //alert(this.approveRejecInstructions);
            this.formErrors='';
            this.loading =false;
            let self =this;
            this.$validator.validateAll("uscisstatus").then((result) => {
                if (result) {
                  
	                
                    // this.approveRejec_Instructions="* Instructions is required"

                    let payload_data = {
                        petitionId: this.petitionDetails._id,
                        comment: this.comments,
                        action: this.casestatus.value,
                         "today": moment().format("YYYY-MM-DD"),
                         "typeName":this.petitionDetails.typeDetails.name,
                         "subTypeName":this.petitionDetails.subTypeDetails.name
                    };

                    let rfepayload = {
                        petitionId: this.petitionDetails._id,
                        comment: this.comments,
                        description: this.comments,
                        action: this.casestatus.value, //'UPDATE_USCIS_RESPONSE'
                         "today": moment().format("YYYY-MM-DD"),
                          "typeName":this.petitionDetails.typeDetails.name,
                         "subTypeName":this.petitionDetails.subTypeDetails.name
                    };
                    // "action": "QUESTIONNIRE_APPROVED" // "QUESTIONNIRE_REJECTED" / "CASE_APPROVED" / "LCA_CERTIFIED_FOR_PETITION" / "READY_FOR_FILING" / "USCIS_APPROVED" / "USCIS_RECEIVED_RFE" / "USCIS_DENIED"

                    if (this.casestatus.value == "USCIS_RECEIVED_RFE") {
                        payload_data["today"] = moment().format("YYYY-MM-DD");
                        payload_data["typeName"] = this.petitionDetails.typeDetails.name;
                        payload_data["subTypeName"] = this.petitionDetails.subTypeDetails.name;

                        rfepayload["today"] = moment().format("YYYY-MM-DD");
                        rfepayload["typeName"] = this.petitionDetails.typeDetails.name;
                        rfepayload["subTypeName"] = this.petitionDetails.subTypeDetails.name;

                        rfepayload["issuedDate"] = moment(this.issuedDate).format(
                            "YYYY-MM-DD"
                        );
                        rfepayload["receivedDate"] = moment(this.receivedDate).format(
                            "YYYY-MM-DD"
                        );
                        rfepayload["dueDate"] = moment(this.dueDate).format("YYYY-MM-DD");
                      
                    }
                      rfepayload["documents"] = this.uscisdocument;
                    this.loading =true;
                    this.filesAreuploading =false;
                    rfepayload["today"] = moment().format("YYYY-MM-DD");
                    //alert(JSON.stringify(rfepayload)); 
                    this.$store
                        .dispatch("manageApproval_process", rfepayload)
                        .then((response) => {
                            if (self.casestatus.value == "USCIS_RECEIVED_RFE") {
                                self.$store.dispatch("fileRFE", rfepayload).then((response) => {
                                   
                                    //this.showMessages(response.message);
                                    self.showToster({ message:response.message , isError: false})
                                    self.updateUSCISstatusPopup = false;

                                     this.reloadWallList()
                                });
                            } else {
                             
                               
                               // this.showMessages(response.message);
                                  self.showToster({ message:response.message , isError: false})
                                self.updateUSCISstatusPopup = false;
                                 this.reloadWallList()
                            }
                              this.loading =false;
                        })
                        .catch((error) => {
                           this.loading =false;
                           this.filesAreuploading =false;
                           this.formErrors =error;
                          this.showToster({ message: error, isError: true });
                        });
                }else{
                 // this.showToster({ message:"Invalid data" , isError: true});
                }
            });
        },

   // petetioner
    getpetetioner(  approveConformpopUp =false) {
            let companyId = this.checkProperty(this.item ,"data", "companyId")
            this.$vs.loading();
            this.$store
                .dispatch("petitioner/getpetetioner", {
                    companyId: companyId
                })
                .then(response => {
                  this.approveConformpopUp =approveConformpopUp;
                   this.$vs.loading.close();   
                    this.petitioner = response;
                    this.petitioner['petitionerId'] = response['userId'];
                }).catch((err)=>{

                 this.$vs.loading.close();   
                });
   
    },
    openApprovepopup(status=2 ,txt=''){
        this.actionText = "Do you want to "+txt+" ?",
        this.popupbtnTxt = txt;
        this.selectedStatus = status;
        this.approveConformpopUp =false;
          this.getpetetioner(true);

      }, 
      changetPetitionerstatus( ){
        let post_data = {"companyId":this.petitioner['_id'], "statusId":this.selectedStatus };
        let sts = _.find(this.all_statusids ,{"id":this.selectedStatus});
        if(sts && _.has(sts,"name")){
          post_data['statusName'] = sts['name']

        }
        //alert(JSON.stringify(post_data));

        //post_data = Object.assign(post_data,{"petitionerId":this.selectedpetitioner['_id'] ,"statusId":this.selectedStatus})
         this.loading = true;
         this.formErrors ='';
          this.$store.dispatch("commonAction", {data:post_data ,"path":"/company/update-status"}).then((res) => {
              this.approveConformpopUp =false;
              this.loading =false;
              this.showToster({message:res.message,isError:false });
              this.reloadWallList();
               

            }).catch((error) => {
                this.loading =false;
                this.formErrors = error;
                this.showToster({message:error,isError:true });
               

            });

      }, 
      getCompanyStatusList(){
        this.all_statusids =[];
         let postdata ={
        page:1,
        perpage: 1000,
        category: "company_status",
       
      };
        this.$store.dispatch("getMasterData" ,postdata)
        .then((res)=>{
          this.all_statusids = res['list'];
          this.all_statusids = _.filter(this.all_statusids ,(item)=>{
            return [1,2,3,4].indexOf(item['id'])>-1;

           })

        })
        .catch(()=>{

        })


      },  

      findDetailsPage(petitionId=''){

         

        if(petitionId){
          if([51].indexOf(this.getUserRoleId) >-1){
            if((
              (this.assignmentActivityes.indexOf(this.checkProperty( this.item ,'data' , 'category'))>-1)
             //|| (this.petitionToDoList.indexOf(this.checkProperty( this.item ,'data' , 'category')) >-1 && this.checkProperty( this.item ,'status' ))
             || (this.checkProperty( this.item ,'data' , 'category')== 'CASE_APPROVED' && this.checkProperty( this.item ,'status'))
             || (this.checkProperty( this.item ,"data" , "category")== "REQUEST_PETITIONER_SIGN" && this.checkProperty( this.item ,"status"))
             || (this.checkProperty( this.item ,'data' , 'category')== 'APPROVED_BY_DOC_MANAGER' && this.checkProperty( this.item ,'status'))
             || (this.checkProperty( this.item ,'data' , 'category')== 'SUBMIT_TO_USCIS' && this.checkProperty( this.item ,'status'))
             || (['UPDATE_USCIS_RECEIPT_NUMBER' ,'COURIER_TRACKING'].indexOf(this.checkProperty( this.item ,'data' , 'category'))>-1 && this.checkProperty( this.item ,'status'))
             || (['UPDATE_USCIS_RESPONSE'].indexOf(this.checkProperty( this.item ,'data' , 'category'))>-1 && this.checkProperty( this.item ,'status'))
            )){

              this.$router.push("/petition-details/"+petitionId);

            }else{
                this.$router.push("/questionnaire/"+petitionId);
            }
          
          }else{
            this.$router.push("/petition-details/"+petitionId);
          }
        }

      }
    
   

  },
 data: () => ({
  editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },
   notifyPetitioner:false,
   emailDocsForSign:false,
   isotopGrid:null,
   isInvaliedFileName:false,
    documentTypes:["Original" ,"Electronic" ],
    jaquery: null,
    settingCaseNumber:false,
    setCode:false,
    newCaseCode:'',
    confCaseCode:'',

   item:null,
   isAddcls:false,
    documentsViewPopup:false,
    skipedActivityList:[],
    workFlowDetails:null,
   assignMentUsersList:{
      "ASSIGN_SUPERVISOR":"SUPERVISOR_LIST",
      "ASSIGN_PARALEGAL":"PARALEGAL_LIST",
      "ASSIGN_DOCUMENTATION_MANAGER":"DOCUMENTATION_MANAGER_LIST",
      "ASSIGN_DOCUMENTATION_EXECUTIVE":"DOCUMENTATION_EXECUTIVE_LIST",
      "ASSIGN_ATTORNEY":"ATTORNEY_LIST",
      },
      petitionToDoList:[],
      assignmentActivityes:[],
       showPopup:false,
        selectedUser:null,
        usersList:[],
        formErrors: "",
        comments:'',
        loading:false,
        petitionDetails:null,
        skipedActivity:false,
        approveCasePopup:false,
        lcaDetails:null,
        approveOrRejectDocs:false,

        //tenant Relate Todo
        tenantTodoList:['TENANT_CREATED' ],
        tenantDetails:null,
        tntActionText:'',
        popuptntTxt:'',
        selectedtenantStatus:0,
        approveTenantConformpopUp:false,

        //Request for signin
        requestsignPopup:false,
        formsAndLettersList:[],
        checkFormsandLatters:false,
        requestsignCommentError:false,

        //Submit to Uscis
        scannedCopies:[],
        submiTouscisPopup:false,

        //Courier Tracking
        updateTrackingPopup:false,
        tracking: {documents:[],receiptNumber:null,receiptName:null},
        trackingdoc: [],
        filesAreuploading:false,
        courierList:[],

       //update USCIS Status
       updateUSCISstatusPopup:false,
       uscisstatuslist: [
      {
        value: "USCIS_APPROVED",
        text: "Case Approved",
      },
      {
        value: "USCIS_RECEIVED_RFE",
        text: "RFE Received",
      },
      {
        value: "USCIS_DENIED",
        text: "Case Denied",
      },
      {
        value: "USCIS_WITHDRAWN",
        text: "Case Withdrawn",
      },
    ],
    casestatus:null,
     issuedDate: null,
    receivedDate: null,
    dueCate: null,
    dueDate:null,
    openDate: new Date().setFullYear(new Date().getFullYear()),
    startEligibleDate: new Date().setFullYear(new Date().getFullYear()),
    uscisdocument:[],

    //COMPANY_CREATED
    petitioner:null,
    actionText:"",
    popupbtnTxt:'',
    selectedStatus:null,
    approveConformpopUp:false,
    //all_statusids:[]
  }),
  mounted(){
      this.jaquery = JQuery;

      this.isAddcls =false;
      this.petitionToDoList = ["CREATE_PETITION" ,'SUBMIT_BY_BENEFICIARY','LCA_REQUEST' ,'SUBMIT_TO_LAW_FIRM' ,'ASSIGN_SUPERVISOR' ,"ASSIGN_PARALEGAL" ,"ASSIGN_DOCUMENTATION_MANAGER","ASSIGN_DOCUMENTATION_EXECUTIVE" ,"ASSIGN_ATTORNEY" ,"REQUEST_DOC_EXECUTIVE_TO_UPLOAD","UPLOAD_BY_DOC_EXECUTIVE" ,"CASE_APPROVED"]
      this.assignmentActivityes = ['ASSIGN_SUPERVISOR' ,"ASSIGN_PARALEGAL" ,"ASSIGN_DOCUMENTATION_MANAGER","ASSIGN_DOCUMENTATION_EXECUTIVE" ,"ASSIGN_ATTORNEY"]
      this.tenantTodoList = ['TENANT_CREATED' ];
      //this.getCompanyStatusList();
      this.assignMentUsersList = {
      "ASSIGN_SUPERVISOR":"SUPERVISOR_LIST",
      "ASSIGN_PARALEGAL":"PARALEGAL_LIST",
      "ASSIGN_DOCUMENTATION_MANAGER":"DOCUMENTATION_MANAGER_LIST",
      "ASSIGN_DOCUMENTATION_EXECUTIVE":"DOCUMENTATION_EXECUTIVE_LIST",
      "ASSIGN_ATTORNEY":"ATTORNEY_LIST",
      };
      this.initIsotop();
      
       
 } ,
  computed:{
    
   
             
      
      
   
     
    
  }
};
</script>